import { j as z, r as Vt } from "./jsx-runtime-3tyXYecC.mjs";
import { createContext as qt, useContext as Ft, useImperativeHandle as ze, memo as De, useCallback as It, useMemo as Wt, PureComponent as Zt, createElement as kt, useRef as U, useEffect as J, Fragment as Re } from "react";
import Ee, { flushSync as Qt } from "react-dom";
import { l as Pe } from "./lodash-5ofSKtz3.mjs";
import { c as Ce, b as _e, a as Me } from "./hook-CrqgbaQ-.mjs";
import { a as He } from "./hooks-DlFaCTNC.mjs";
import { f as k } from "./index-LyFokDcn.mjs";
import { m as ut } from "./tss-DN0acMKN.mjs";
import { a as We, g as Ne } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { p as Jt } from "./index-BpaEWJM0.mjs";
import { I as Oe, r as te } from "./_react-dom_commonjs-external-Bs0rGxnp.mjs";
import { L as Te } from "./layout-box-DFBM-kSI.mjs";
import { I as Be } from "./icon-v2-DGtVEk7e.mjs";
import { _ as ee } from "./composeRefs-YONvD-rx.mjs";
import { F as Rt } from "./flex-Cc3osQLf.mjs";
import { H as Ae } from "./headline-DF2GOgMa.mjs";
import { I as Et } from "./icon-button-BxDvkq_l.mjs";
const Le = ut()(({ borderRadiuses: t }) => ({
  footer: {
    borderBottomLeftRadius: k.ifFeature("encore", t[300], void 0),
    borderBottomRightRadius: k.ifFeature("encore", t[300], void 0),
    flexGrow: 1,
    minHeight: "64px",
    overflow: "hidden"
  }
})), Fe = ({ children: t }) => {
  const { classes: i } = Le();
  return /* @__PURE__ */ z.jsx("div", { className: i.footer, children: t });
}, Ie = ut()(({ borderRadiuses: t, constructs: i, palette: e, spacing: o }) => ({
  header: {
    backgroundColor: k.ifFeature("encore", i.surface.neutral.xxWeak, e.gray[100]),
    borderTopLeftRadius: k.ifFeature("encore", t[300], void 0),
    borderTopRightRadius: k.ifFeature("encore", t[300], void 0),
    height: "100%",
    padding: o(1.5, 2)
  },
  dragHandle: {
    cursor: "move"
  }
})), ie = qt({
  closeButtonApiRef: null
}), oe = qt({
  draggable: !1,
  dragHandleRef: null
}), ke = ({ apiRef: t, onClose: i, icon: e, title: o, biId: n }) => {
  const { classes: r } = Ie(), { closeButtonApiRef: a } = Ft(ie), { draggable: s, dragHandleRef: l } = Ft(oe), u = ee(t, a);
  return ze(
    u,
    () => ({
      onClose: () => i()
    }),
    [i]
  ), /* @__PURE__ */ z.jsx(Rt, { flexDirection: "column", flexGrow: 0, children: /* @__PURE__ */ z.jsx("div", { className: r.header, children: /* @__PURE__ */ z.jsxs(Rt, { alignItems: "center", gap: 1, justifyContent: "space-between", children: [
    /* @__PURE__ */ z.jsxs(Rt, { alignItems: "center", gap: 2, children: [
      s && /* @__PURE__ */ z.jsx("div", { ref: l, children: /* @__PURE__ */ z.jsx(
        Et,
        {
          "aria-label": window.jQuery ? $.__("Move dialog") : "Move dialog",
          className: `${r.dragHandle} drag-handle`,
          floatingIcon: !0,
          icon: "grip-dots-regular",
          noBoundingBox: !0,
          size: "large",
          type: "button"
        }
      ) }),
      /* @__PURE__ */ z.jsx(Ae, { color: k.ifFeature("encore", "primary", "neutral-strong"), icon: e, size: "small", children: o })
    ] }),
    k.ifFeature(
      "encore",
      /* @__PURE__ */ z.jsx(
        Et,
        {
          "aria-label": window.jQuery ? $.__("close modal") : "close modal",
          biId: n,
          icon: "xmark-solid",
          onClick: i,
          size: "extra-small",
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ z.jsx(
        Et,
        {
          "aria-label": window.jQuery ? $.__("close modal") : "close modal",
          biId: n,
          icon: /* @__PURE__ */ z.jsx(Oe, { "aria-hidden": "true" }),
          noBoundingBox: !0,
          onClick: i,
          type: "button"
        }
      )
    )
  ] }) }) });
}, at = 400, Nt = 600, Ot = 300, ne = 64, re = 24, se = 24, ct = 24, mt = 24, vt = 16, T = 4, ae = 18, je = 4, Xe = 10, Ye = 4, Ue = 10, Tt = (t, i) => {
  if (i.current && t.current) {
    const { top: e } = i.current.getBoundingClientRect(), { top: o, right: n } = t.current.getBoundingClientRect(), r = window.innerWidth - n - vt + T, a = e - (e - o) + T;
    return { x: Math.trunc(r), y: Math.trunc(a) };
  }
  return { x: ne, y: re };
}, $e = (t) => {
  if (t.current) {
    const { height: i, width: e } = t.current.getBoundingClientRect(), o = Math.round(e - 2 * T);
    return { height: Math.round(i - 2 * T), width: o };
  }
  return { height: Nt, width: Ot };
}, Ge = ({ containerRef: t, decoyRef: i }) => {
  if (i.current && t.current) {
    const { top: e, right: o } = i.current.getBoundingClientRect(), { top: n, right: r } = t.current.getBoundingClientRect(), a = o - r - T + vt, s = e - n + T - ct;
    return { x: a, y: s };
  }
  return { x: 0, y: 0 };
}, Ke = (t, i, e) => {
  const { top: o, bottom: n, left: r, right: a } = i, { top: s, bottom: l, left: u, right: c } = e, h = typeof t.x == "number" ? t.x : parseInt(t.x, 10), g = typeof t.y == "number" ? t.y : parseInt(t.y, 10);
  let v = h;
  a + T > c ? v = h + (c - a - T) : r < u && (v = h + (u - r));
  let b = g;
  o < s ? b = g + (s - o + T) : l < n + T && (b = g - (n - l + T));
  const w = Math.max(0, Math.trunc(v)), x = Math.max(0, Math.trunc(b));
  return { x: w, y: x };
}, Ve = (t, i, e, o) => {
  const { top: n, bottom: r } = t;
  return Math.trunc(i) <= r + T && (typeof e == "string" ? parseInt(e.replace("px", ""), 10) : e) > at ? (o == null || o(`${Math.trunc(Math.max(at, i - n + T))}px`), Math.trunc(Math.max(at, i - n + T))) : e;
}, qe = (t) => {
  const i = typeof t == "string" ? parseInt(t.replace("px", ""), 10) : t;
  return window.innerWidth - se - vt <= i;
};
function Ze(t, i) {
  let { x: e, y: o } = t;
  const n = i.shiftKey ? Ue : Ye;
  switch (i.key) {
    case "ArrowUp":
      o = Math.max(0, o - n);
      break;
    case "ArrowDown":
      o += n;
      break;
    case "ArrowLeft":
      e = Math.max(0, e - n);
      break;
    case "ArrowRight":
      e += n;
      break;
  }
  return { x: e, y: o };
}
function Qe(t, i) {
  const e = i.shiftKey ? Xe : je, o = window.innerHeight - ct - mt;
  let n = t;
  switch (i.key) {
    case "ArrowUp":
      n = Math.max(t - e, at);
      break;
    case "ArrowDown":
      n = Math.min(t + e, o);
      break;
  }
  return n;
}
const Je = ({
  oldWindowHeight: t,
  newWindowHeight: i,
  distanceFromBottom: e,
  size: o,
  showDialog: n,
  dialogMeasurements: r
}) => {
  if (i !== t && n) {
    const { top: a } = r, { height: s, width: l } = o, u = Number(s), c = t - i, h = window.innerHeight - a - e, g = Math.max(at, u - c);
    return { height: Math.min(h, g), width: l };
  }
  return o;
}, ti = (t, i, e) => {
  const o = e - i;
  return t + o;
}, le = (t) => ({ getState: i, setState: e }) => {
  const { containerRef: o, rndRef: n, boundaryRef: r } = t;
  if (o.current && n.current && r.current) {
    const a = o.current.getBoundingClientRect(), s = r.current.getBoundingClientRect(), l = i().position, u = Ke(l, a, s);
    e({ position: u, showDialog: !0 });
  }
}, ei = (t, i) => {
  if (t.current && i.current) {
    const e = t.current.getBoundingClientRect();
    return i.current.getBoundingClientRect().bottom - e.bottom + ct + mt + T;
  }
  return 0;
}, ii = ({ containerRef: t, decoyRef: i, boundaryRef: e }) => ({ setState: o }) => {
  if (t.current && i.current && e.current) {
    const { height: n, width: r } = $e(i), a = ei(i, e), { x: s, y: l } = Ge({ containerRef: t, decoyRef: i });
    o({ absolutePositionCalculated: !0, distanceFromBottom: a, position: { x: s, y: l }, size: { height: n, width: r } });
  }
}, oi = (t) => ({ getState: i, setState: e }) => {
  const { containerRef: o, rndRef: n, boundaryRef: r, onResize: a } = t;
  if (o.current && n.current && r.current) {
    const { top: s, bottom: l } = o.current.getBoundingClientRect(), { bottom: u } = r.current.getBoundingClientRect(), { height: c, width: h } = i().size, g = Ve({ bottom: l, top: s }, u, c, a);
    e({ size: { height: g, width: h } });
  }
}, ni = (t) => ({ getState: i }) => {
  const { containerRef: e, boundaryRef: o } = t, { width: n } = i().size;
  return !!(e.current && o.current && qe(n));
}, ri = (t) => ({ setState: i }) => {
  i({
    position: { x: 0, y: 0 },
    absolutePositionCalculated: !1,
    showDialog: !1,
    size: t
  });
}, si = (t) => ({ getState: i, setState: e }) => {
  const o = i().size, n = window.getComputedStyle(t).height;
  e({ size: { ...o, height: n } });
}, ai = (t, i) => ({ getState: e }) => {
  const { cursorStyle: o } = e();
  document.body.style.cursor = o;
  const n = window.getComputedStyle(t).height;
  i == null || i(n);
}, li = () => ({ setState: t }) => {
  const { cursor: i } = window.getComputedStyle(document.body);
  t({ cursorStyle: i }), document.body.style.cursor = "ns-resize";
}, ui = (t, i, e, o) => ({ setState: n }) => {
  const { x: r, y: a } = t;
  if (n({ position: { x: r, y: a } }), o && i.current && e.current) {
    const { x: s, y: l } = Tt(i, e);
    o(`${l}px`, `${s}px`);
  }
}, ci = (t) => ({ getState: i, setState: e }) => {
  const { event: o, onResize: n } = t;
  if (o.key !== "ArrowUp" && o.key !== "ArrowDown")
    return;
  o.preventDefault();
  const { size: r } = i(), a = typeof r.height == "string" ? parseInt(r.height, 10) : r.height, s = Qe(a, o), l = { ...r, height: s };
  e({ size: l }), s !== a && n && n(`${s}px`);
}, di = (t) => ({ getState: i, setState: e, dispatch: o }) => {
  const { boundaryRef: n, containerRef: r, decoyRef: a, event: s, onDrag: l, rndRef: u } = t;
  if (s.key !== "ArrowUp" && s.key !== "ArrowDown" && s.key !== "ArrowLeft" && s.key !== "ArrowRight")
    return;
  s.preventDefault();
  const { position: c } = i(), h = typeof c.x == "string" ? parseInt(c.x, 10) : c.x, g = typeof c.y == "string" ? parseInt(c.y, 10) : c.y, { x: v, y: b } = Ze({ x: h, y: g }, s);
  if (e({ position: { x: v, y: b } }), o(le({ boundaryRef: n, containerRef: r, rndRef: u })), l && r.current && a.current) {
    const { x, y: D } = Tt(r, a);
    l(`${D}px`, `${x}px`);
  }
}, hi = (t, i) => ({ setState: e, getState: o }) => {
  const { size: n, windowHeight: r, showDialog: a, distanceFromBottom: s } = o();
  if (i.current && t.current) {
    const l = document.documentElement.clientHeight, u = t.current.getBoundingClientRect(), c = Je({
      dialogMeasurements: u,
      distanceFromBottom: s,
      newWindowHeight: l,
      oldWindowHeight: r,
      showDialog: a,
      size: n
    });
    e({
      absolutePositionCalculated: !0,
      showDialog: !0,
      size: c,
      windowHeight: l
    });
  }
}, pi = (t) => ({ setState: i, getState: e }) => {
  if (t.current) {
    const { position: o, windowWidth: n, previousWindowWidth: r } = e(), { x: a } = o, s = typeof a == "string" ? parseInt(a, 10) : a, l = ti(s, r, n);
    i({
      position: {
        ...o,
        x: l
      },
      previousWindowWidth: n
    });
  }
}, fi = {
  calculateInitialSizeAndPosition: ii,
  handleDragStop: ui,
  handleKeyboardRepositioning: di,
  handleKeyboardResize: ci,
  isWindowSmallHorizontally: ni,
  keepInBounds: le,
  moveHorizontallyWithWindow: pi,
  moveVerticallyWithWindow: hi,
  onResizeEnd: ai,
  onResizeFunction: si,
  onResizeStart: li,
  resetStore: ri,
  updateSize: (t) => ({ setState: i }) => {
    i({ size: t });
  },
  updateWindowHeight: (t) => ({ setState: i }) => {
    i({ windowHeight: t });
  },
  updateWindowResizeHeight: oi,
  updateWindowWidth: (t) => ({ setState: i, getState: e }) => {
    e().previousWindowWidth === 0 ? i({
      previousWindowWidth: t,
      windowWidth: t
    }) : i({ windowWidth: t });
  }
}, ue = _e({
  actions: fi,
  initialState: {
    absolutePositionCalculated: !1,
    cursorStyle: "default",
    distanceFromBottom: 0,
    position: { x: 0, y: 0 },
    previousWindowWidth: 0,
    showDialog: !1,
    size: { height: Nt, width: Ot },
    windowHeight: 0,
    windowWidth: 0
  },
  name: "DialogStore"
}), gi = Ce(ue), ot = Me(ue), mi = ut()((t, i) => {
  const { borderRadiuses: e, constructs: o, mixins: n, palette: r, spacing: a } = t, { initialHeight: s, resizable: l, open: u, width: c, zIndex: h, initialOffsetTop: g, initialOffsetRight: v } = i, b = typeof s == "number" ? `${s}px` : s;
  return {
    root: {
      backgroundColor: k.ifFeature("encore", o.surface.neutral.inverted, r.background.default),
      border: "none",
      borderRadius: k.ifFeature("encore", e[400], "inherit"),
      boxShadow: k.ifFeature("encore", n.boxShadow("700", o.surface.neutral.xxStrong), "0px 8px 16px 0px #00000026"),
      display: u ? "flex" : "none",
      flexDirection: "column",
      height: l ? `calc(${b} - ${ae}px)` : b,
      padding: k.ifFeature("encore", a(T / 8), 0),
      pointerEvents: "auto",
      position: "absolute",
      right: v,
      textAlign: "left",
      visibility: "hidden",
      width: c
    },
    resizeHandleOverrides: {
      // These are to override React-rnd's resize handle styles
      height: "unset !important",
      "&:hover": {
        cursor: "unset !important"
      }
    },
    boundaryContainer: {
      bottom: mt,
      left: se,
      right: vt,
      top: ct,
      pointerEvents: "none",
      // This allows clicking through the container
      position: "fixed",
      zIndex: h
    },
    visible: {
      visibility: "visible"
    },
    hiddenDialog: {
      right: v,
      top: g
    }
  };
});
var yt = { exports: {} }, ce = {};
function de(t) {
  var i, e, o = "";
  if (typeof t == "string" || typeof t == "number") o += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (i = 0; i < t.length; i++) t[i] && (e = de(t[i])) && (o && (o += " "), o += e);
  else for (i in t) t[i] && (o && (o += " "), o += i);
  return o;
}
function jt() {
  for (var t, i, e = 0, o = ""; e < arguments.length; ) (t = arguments[e++]) && (i = de(t)) && (o && (o += " "), o += i);
  return o;
}
const vi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: jt,
  default: jt
}, Symbol.toStringTag, { value: "Module" })), yi = /* @__PURE__ */ We(vi);
var P = {}, q = {};
Object.defineProperty(q, "__esModule", {
  value: !0
});
q.dontSetMe = zi;
q.findInArray = bi;
q.int = Si;
q.isFunction = wi;
q.isNum = xi;
function bi(t, i) {
  for (let e = 0, o = t.length; e < o; e++)
    if (i.apply(i, [t[e], e, t])) return t[e];
}
function wi(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Function]";
}
function xi(t) {
  return typeof t == "number" && !isNaN(t);
}
function Si(t) {
  return parseInt(t, 10);
}
function zi(t, i, e) {
  if (t[i])
    return new Error("Invalid prop ".concat(i, " passed to ").concat(e, " - do not set this, set it on the child."));
}
var nt = {};
Object.defineProperty(nt, "__esModule", {
  value: !0
});
nt.browserPrefixToKey = pe;
nt.browserPrefixToStyle = Di;
nt.default = void 0;
nt.getPrefix = he;
const Pt = ["Moz", "Webkit", "O", "ms"];
function he() {
  var t;
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u") return "";
  const e = (t = window.document) === null || t === void 0 || (t = t.documentElement) === null || t === void 0 ? void 0 : t.style;
  if (!e || i in e) return "";
  for (let o = 0; o < Pt.length; o++)
    if (pe(i, Pt[o]) in e) return Pt[o];
  return "";
}
function pe(t, i) {
  return i ? "".concat(i).concat(Ri(t)) : t;
}
function Di(t, i) {
  return i ? "-".concat(i.toLowerCase(), "-").concat(t) : t;
}
function Ri(t) {
  let i = "", e = !0;
  for (let o = 0; o < t.length; o++)
    e ? (i += t[o].toUpperCase(), e = !1) : t[o] === "-" ? e = !0 : i += t[o];
  return i;
}
nt.default = he();
Object.defineProperty(P, "__esModule", {
  value: !0
});
P.addClassName = me;
P.addEvent = Ci;
P.addUserSelectStyles = Fi;
P.createCSSTransform = Ti;
P.createSVGTransform = Bi;
P.getTouch = Ai;
P.getTouchIdentifier = Li;
P.getTranslation = Bt;
P.innerHeight = Wi;
P.innerWidth = Ni;
P.matchesSelector = ge;
P.matchesSelectorAndParentsTo = Pi;
P.offsetXYFromParent = Oi;
P.outerHeight = Mi;
P.outerWidth = Hi;
P.removeClassName = ve;
P.removeEvent = _i;
P.removeUserSelectStyles = Ii;
var j = q, Xt = Ei(nt);
function fe(t) {
  if (typeof WeakMap != "function") return null;
  var i = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
  return (fe = function(o) {
    return o ? e : i;
  })(t);
}
function Ei(t, i) {
  if (t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var e = fe(i);
  if (e && e.has(t))
    return e.get(t);
  var o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in t)
    if (r !== "default" && Object.prototype.hasOwnProperty.call(t, r)) {
      var a = n ? Object.getOwnPropertyDescriptor(t, r) : null;
      a && (a.get || a.set) ? Object.defineProperty(o, r, a) : o[r] = t[r];
    }
  return o.default = t, e && e.set(t, o), o;
}
let dt = "";
function ge(t, i) {
  return dt || (dt = (0, j.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(e) {
    return (0, j.isFunction)(t[e]);
  })), (0, j.isFunction)(t[dt]) ? t[dt](i) : !1;
}
function Pi(t, i, e) {
  let o = t;
  do {
    if (ge(o, i)) return !0;
    if (o === e) return !1;
    o = o.parentNode;
  } while (o);
  return !1;
}
function Ci(t, i, e, o) {
  if (!t) return;
  const n = {
    capture: !0,
    ...o
  };
  t.addEventListener ? t.addEventListener(i, e, n) : t.attachEvent ? t.attachEvent("on" + i, e) : t["on" + i] = e;
}
function _i(t, i, e, o) {
  if (!t) return;
  const n = {
    capture: !0,
    ...o
  };
  t.removeEventListener ? t.removeEventListener(i, e, n) : t.detachEvent ? t.detachEvent("on" + i, e) : t["on" + i] = null;
}
function Mi(t) {
  let i = t.clientHeight;
  const e = t.ownerDocument.defaultView.getComputedStyle(t);
  return i += (0, j.int)(e.borderTopWidth), i += (0, j.int)(e.borderBottomWidth), i;
}
function Hi(t) {
  let i = t.clientWidth;
  const e = t.ownerDocument.defaultView.getComputedStyle(t);
  return i += (0, j.int)(e.borderLeftWidth), i += (0, j.int)(e.borderRightWidth), i;
}
function Wi(t) {
  let i = t.clientHeight;
  const e = t.ownerDocument.defaultView.getComputedStyle(t);
  return i -= (0, j.int)(e.paddingTop), i -= (0, j.int)(e.paddingBottom), i;
}
function Ni(t) {
  let i = t.clientWidth;
  const e = t.ownerDocument.defaultView.getComputedStyle(t);
  return i -= (0, j.int)(e.paddingLeft), i -= (0, j.int)(e.paddingRight), i;
}
function Oi(t, i, e) {
  const n = i === i.ownerDocument.body ? {
    left: 0,
    top: 0
  } : i.getBoundingClientRect(), r = (t.clientX + i.scrollLeft - n.left) / e, a = (t.clientY + i.scrollTop - n.top) / e;
  return {
    x: r,
    y: a
  };
}
function Ti(t, i) {
  const e = Bt(t, i, "px");
  return {
    [(0, Xt.browserPrefixToKey)("transform", Xt.default)]: e
  };
}
function Bi(t, i) {
  return Bt(t, i, "");
}
function Bt(t, i, e) {
  let {
    x: o,
    y: n
  } = t, r = "translate(".concat(o).concat(e, ",").concat(n).concat(e, ")");
  if (i) {
    const a = "".concat(typeof i.x == "string" ? i.x : i.x + e), s = "".concat(typeof i.y == "string" ? i.y : i.y + e);
    r = "translate(".concat(a, ", ").concat(s, ")") + r;
  }
  return r;
}
function Ai(t, i) {
  return t.targetTouches && (0, j.findInArray)(t.targetTouches, (e) => i === e.identifier) || t.changedTouches && (0, j.findInArray)(t.changedTouches, (e) => i === e.identifier);
}
function Li(t) {
  if (t.targetTouches && t.targetTouches[0]) return t.targetTouches[0].identifier;
  if (t.changedTouches && t.changedTouches[0]) return t.changedTouches[0].identifier;
}
function Fi(t) {
  if (!t) return;
  let i = t.getElementById("react-draggable-style-el");
  i || (i = t.createElement("style"), i.type = "text/css", i.id = "react-draggable-style-el", i.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, i.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, t.getElementsByTagName("head")[0].appendChild(i)), t.body && me(t.body, "react-draggable-transparent-selection");
}
function Ii(t) {
  if (t)
    try {
      if (t.body && ve(t.body, "react-draggable-transparent-selection"), t.selection)
        t.selection.empty();
      else {
        const i = (t.defaultView || window).getSelection();
        i && i.type !== "Caret" && i.removeAllRanges();
      }
    } catch {
    }
}
function me(t, i) {
  t.classList ? t.classList.add(i) : t.className.match(new RegExp("(?:^|\\s)".concat(i, "(?!\\S)"))) || (t.className += " ".concat(i));
}
function ve(t, i) {
  t.classList ? t.classList.remove(i) : t.className = t.className.replace(new RegExp("(?:^|\\s)".concat(i, "(?!\\S)"), "g"), "");
}
var Z = {};
Object.defineProperty(Z, "__esModule", {
  value: !0
});
Z.canDragX = Xi;
Z.canDragY = Yi;
Z.createCoreData = $i;
Z.createDraggableData = Gi;
Z.getBoundPosition = ki;
Z.getControlPosition = Ui;
Z.snapToGrid = ji;
var I = q, st = P;
function ki(t, i, e) {
  if (!t.props.bounds) return [i, e];
  let {
    bounds: o
  } = t.props;
  o = typeof o == "string" ? o : Ki(o);
  const n = At(t);
  if (typeof o == "string") {
    const {
      ownerDocument: r
    } = n, a = r.defaultView;
    let s;
    if (o === "parent" ? s = n.parentNode : s = r.querySelector(o), !(s instanceof a.HTMLElement))
      throw new Error('Bounds selector "' + o + '" could not find an element.');
    const l = s, u = a.getComputedStyle(n), c = a.getComputedStyle(l);
    o = {
      left: -n.offsetLeft + (0, I.int)(c.paddingLeft) + (0, I.int)(u.marginLeft),
      top: -n.offsetTop + (0, I.int)(c.paddingTop) + (0, I.int)(u.marginTop),
      right: (0, st.innerWidth)(l) - (0, st.outerWidth)(n) - n.offsetLeft + (0, I.int)(c.paddingRight) - (0, I.int)(u.marginRight),
      bottom: (0, st.innerHeight)(l) - (0, st.outerHeight)(n) - n.offsetTop + (0, I.int)(c.paddingBottom) - (0, I.int)(u.marginBottom)
    };
  }
  return (0, I.isNum)(o.right) && (i = Math.min(i, o.right)), (0, I.isNum)(o.bottom) && (e = Math.min(e, o.bottom)), (0, I.isNum)(o.left) && (i = Math.max(i, o.left)), (0, I.isNum)(o.top) && (e = Math.max(e, o.top)), [i, e];
}
function ji(t, i, e) {
  const o = Math.round(i / t[0]) * t[0], n = Math.round(e / t[1]) * t[1];
  return [o, n];
}
function Xi(t) {
  return t.props.axis === "both" || t.props.axis === "x";
}
function Yi(t) {
  return t.props.axis === "both" || t.props.axis === "y";
}
function Ui(t, i, e) {
  const o = typeof i == "number" ? (0, st.getTouch)(t, i) : null;
  if (typeof i == "number" && !o) return null;
  const n = At(e), r = e.props.offsetParent || n.offsetParent || n.ownerDocument.body;
  return (0, st.offsetXYFromParent)(o || t, r, e.props.scale);
}
function $i(t, i, e) {
  const o = !(0, I.isNum)(t.lastX), n = At(t);
  return o ? {
    node: n,
    deltaX: 0,
    deltaY: 0,
    lastX: i,
    lastY: e,
    x: i,
    y: e
  } : {
    node: n,
    deltaX: i - t.lastX,
    deltaY: e - t.lastY,
    lastX: t.lastX,
    lastY: t.lastY,
    x: i,
    y: e
  };
}
function Gi(t, i) {
  const e = t.props.scale;
  return {
    node: i.node,
    x: t.state.x + i.deltaX / e,
    y: t.state.y + i.deltaY / e,
    deltaX: i.deltaX / e,
    deltaY: i.deltaY / e,
    lastX: t.state.x,
    lastY: t.state.y
  };
}
function Ki(t) {
  return {
    left: t.left,
    top: t.top,
    right: t.right,
    bottom: t.bottom
  };
}
function At(t) {
  const i = t.findDOMNode();
  if (!i)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return i;
}
var bt = {}, wt = {};
Object.defineProperty(wt, "__esModule", {
  value: !0
});
wt.default = Vi;
function Vi() {
}
Object.defineProperty(bt, "__esModule", {
  value: !0
});
bt.default = void 0;
var Ct = Zi(Vt), L = Lt(Jt), qi = Lt(te), O = P, et = Z, _t = q, lt = Lt(wt);
function Lt(t) {
  return t && t.__esModule ? t : { default: t };
}
function ye(t) {
  if (typeof WeakMap != "function") return null;
  var i = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
  return (ye = function(o) {
    return o ? e : i;
  })(t);
}
function Zi(t, i) {
  if (t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var e = ye(i);
  if (e && e.has(t))
    return e.get(t);
  var o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in t)
    if (r !== "default" && Object.prototype.hasOwnProperty.call(t, r)) {
      var a = n ? Object.getOwnPropertyDescriptor(t, r) : null;
      a && (a.get || a.set) ? Object.defineProperty(o, r, a) : o[r] = t[r];
    }
  return o.default = t, e && e.set(t, o), o;
}
function B(t, i, e) {
  return i = Qi(i), i in t ? Object.defineProperty(t, i, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : t[i] = e, t;
}
function Qi(t) {
  var i = Ji(t, "string");
  return typeof i == "symbol" ? i : String(i);
}
function Ji(t, i) {
  if (typeof t != "object" || t === null) return t;
  var e = t[Symbol.toPrimitive];
  if (e !== void 0) {
    var o = e.call(t, i || "default");
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(t);
}
const Y = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let it = Y.mouse, xt = class extends Ct.Component {
  constructor() {
    super(...arguments), B(this, "dragging", !1), B(this, "lastX", NaN), B(this, "lastY", NaN), B(this, "touchIdentifier", null), B(this, "mounted", !1), B(this, "handleDragStart", (i) => {
      if (this.props.onMouseDown(i), !this.props.allowAnyClick && typeof i.button == "number" && i.button !== 0) return !1;
      const e = this.findDOMNode();
      if (!e || !e.ownerDocument || !e.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: o
      } = e;
      if (this.props.disabled || !(i.target instanceof o.defaultView.Node) || this.props.handle && !(0, O.matchesSelectorAndParentsTo)(i.target, this.props.handle, e) || this.props.cancel && (0, O.matchesSelectorAndParentsTo)(i.target, this.props.cancel, e))
        return;
      i.type === "touchstart" && i.preventDefault();
      const n = (0, O.getTouchIdentifier)(i);
      this.touchIdentifier = n;
      const r = (0, et.getControlPosition)(i, n, this);
      if (r == null) return;
      const {
        x: a,
        y: s
      } = r, l = (0, et.createCoreData)(this, a, s);
      (0, lt.default)("DraggableCore: handleDragStart: %j", l), (0, lt.default)("calling", this.props.onStart), !(this.props.onStart(i, l) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, O.addUserSelectStyles)(o), this.dragging = !0, this.lastX = a, this.lastY = s, (0, O.addEvent)(o, it.move, this.handleDrag), (0, O.addEvent)(o, it.stop, this.handleDragStop));
    }), B(this, "handleDrag", (i) => {
      const e = (0, et.getControlPosition)(i, this.touchIdentifier, this);
      if (e == null) return;
      let {
        x: o,
        y: n
      } = e;
      if (Array.isArray(this.props.grid)) {
        let s = o - this.lastX, l = n - this.lastY;
        if ([s, l] = (0, et.snapToGrid)(this.props.grid, s, l), !s && !l) return;
        o = this.lastX + s, n = this.lastY + l;
      }
      const r = (0, et.createCoreData)(this, o, n);
      if ((0, lt.default)("DraggableCore: handleDrag: %j", r), this.props.onDrag(i, r) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const l = document.createEvent("MouseEvents");
          l.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(l);
        }
        return;
      }
      this.lastX = o, this.lastY = n;
    }), B(this, "handleDragStop", (i) => {
      if (!this.dragging) return;
      const e = (0, et.getControlPosition)(i, this.touchIdentifier, this);
      if (e == null) return;
      let {
        x: o,
        y: n
      } = e;
      if (Array.isArray(this.props.grid)) {
        let l = o - this.lastX || 0, u = n - this.lastY || 0;
        [l, u] = (0, et.snapToGrid)(this.props.grid, l, u), o = this.lastX + l, n = this.lastY + u;
      }
      const r = (0, et.createCoreData)(this, o, n);
      if (this.props.onStop(i, r) === !1 || this.mounted === !1) return !1;
      const s = this.findDOMNode();
      s && this.props.enableUserSelectHack && (0, O.removeUserSelectStyles)(s.ownerDocument), (0, lt.default)("DraggableCore: handleDragStop: %j", r), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, s && ((0, lt.default)("DraggableCore: Removing handlers"), (0, O.removeEvent)(s.ownerDocument, it.move, this.handleDrag), (0, O.removeEvent)(s.ownerDocument, it.stop, this.handleDragStop));
    }), B(this, "onMouseDown", (i) => (it = Y.mouse, this.handleDragStart(i))), B(this, "onMouseUp", (i) => (it = Y.mouse, this.handleDragStop(i))), B(this, "onTouchStart", (i) => (it = Y.touch, this.handleDragStart(i))), B(this, "onTouchEnd", (i) => (it = Y.touch, this.handleDragStop(i)));
  }
  componentDidMount() {
    this.mounted = !0;
    const i = this.findDOMNode();
    i && (0, O.addEvent)(i, Y.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const i = this.findDOMNode();
    if (i) {
      const {
        ownerDocument: e
      } = i;
      (0, O.removeEvent)(e, Y.mouse.move, this.handleDrag), (0, O.removeEvent)(e, Y.touch.move, this.handleDrag), (0, O.removeEvent)(e, Y.mouse.stop, this.handleDragStop), (0, O.removeEvent)(e, Y.touch.stop, this.handleDragStop), (0, O.removeEvent)(i, Y.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, O.removeUserSelectStyles)(e);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var i, e;
    return (i = this.props) !== null && i !== void 0 && i.nodeRef ? (e = this.props) === null || e === void 0 || (e = e.nodeRef) === null || e === void 0 ? void 0 : e.current : qi.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ Ct.cloneElement(Ct.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
bt.default = xt;
B(xt, "displayName", "DraggableCore");
B(xt, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: L.default.bool,
  children: L.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: L.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: L.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(t, i) {
    if (t[i] && t[i].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: L.default.arrayOf(L.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: L.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: L.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: L.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: L.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: L.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: L.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: L.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: L.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _t.dontSetMe,
  style: _t.dontSetMe,
  transform: _t.dontSetMe
});
B(xt, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), t.default = void 0;
  var i = g(Vt), e = c(Jt), o = c(te), n = c(yi), r = P, a = Z, s = q, l = c(bt), u = c(wt);
  function c(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function h(f) {
    if (typeof WeakMap != "function") return null;
    var d = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap();
    return (h = function(m) {
      return m ? p : d;
    })(f);
  }
  function g(f, d) {
    if (f && f.__esModule)
      return f;
    if (f === null || typeof f != "object" && typeof f != "function")
      return { default: f };
    var p = h(d);
    if (p && p.has(f))
      return p.get(f);
    var m = {}, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in f)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(f, y)) {
        var R = S ? Object.getOwnPropertyDescriptor(f, y) : null;
        R && (R.get || R.set) ? Object.defineProperty(m, y, R) : m[y] = f[y];
      }
    return m.default = f, p && p.set(f, m), m;
  }
  function v() {
    return v = Object.assign ? Object.assign.bind() : function(f) {
      for (var d = 1; d < arguments.length; d++) {
        var p = arguments[d];
        for (var m in p)
          Object.prototype.hasOwnProperty.call(p, m) && (f[m] = p[m]);
      }
      return f;
    }, v.apply(this, arguments);
  }
  function b(f, d, p) {
    return d = w(d), d in f ? Object.defineProperty(f, d, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : f[d] = p, f;
  }
  function w(f) {
    var d = x(f, "string");
    return typeof d == "symbol" ? d : String(d);
  }
  function x(f, d) {
    if (typeof f != "object" || f === null) return f;
    var p = f[Symbol.toPrimitive];
    if (p !== void 0) {
      var m = p.call(f, d || "default");
      if (typeof m != "object") return m;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (d === "string" ? String : Number)(f);
  }
  class D extends i.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(d, p) {
      let {
        position: m
      } = d, {
        prevPropsPosition: S
      } = p;
      return m && (!S || m.x !== S.x || m.y !== S.y) ? ((0, u.default)("Draggable: getDerivedStateFromProps %j", {
        position: m,
        prevPropsPosition: S
      }), {
        x: m.x,
        y: m.y,
        prevPropsPosition: {
          ...m
        }
      }) : null;
    }
    constructor(d) {
      super(d), b(this, "onDragStart", (p, m) => {
        if ((0, u.default)("Draggable: onDragStart: %j", m), this.props.onStart(p, (0, a.createDraggableData)(this, m)) === !1) return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), b(this, "onDrag", (p, m) => {
        if (!this.state.dragging) return !1;
        (0, u.default)("Draggable: onDrag: %j", m);
        const S = (0, a.createDraggableData)(this, m), y = {
          x: S.x,
          y: S.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: H,
            y: C
          } = y;
          y.x += this.state.slackX, y.y += this.state.slackY;
          const [N, E] = (0, a.getBoundPosition)(this, y.x, y.y);
          y.x = N, y.y = E, y.slackX = this.state.slackX + (H - y.x), y.slackY = this.state.slackY + (C - y.y), S.x = y.x, S.y = y.y, S.deltaX = y.x - this.state.x, S.deltaY = y.y - this.state.y;
        }
        if (this.props.onDrag(p, S) === !1) return !1;
        this.setState(y);
      }), b(this, "onDragStop", (p, m) => {
        if (!this.state.dragging || this.props.onStop(p, (0, a.createDraggableData)(this, m)) === !1) return !1;
        (0, u.default)("Draggable: onDragStop: %j", m);
        const y = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: H,
            y: C
          } = this.props.position;
          y.x = H, y.y = C;
        }
        this.setState(y);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: d.position ? d.position.x : d.defaultPosition.x,
        y: d.position ? d.position.y : d.defaultPosition.y,
        prevPropsPosition: {
          ...d.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, d.position && !(d.onDrag || d.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var d, p;
      return (d = (p = this.props) === null || p === void 0 || (p = p.nodeRef) === null || p === void 0 ? void 0 : p.current) !== null && d !== void 0 ? d : o.default.findDOMNode(this);
    }
    render() {
      const {
        axis: d,
        bounds: p,
        children: m,
        defaultPosition: S,
        defaultClassName: y,
        defaultClassNameDragging: R,
        defaultClassNameDragged: H,
        position: C,
        positionOffset: N,
        scale: E,
        ...A
      } = this.props;
      let X = {}, G = null;
      const Q = !!!C || this.state.dragging, tt = C || S, K = {
        // Set left if horizontal drag is enabled
        x: (0, a.canDragX)(this) && Q ? this.state.x : tt.x,
        // Set top if vertical drag is enabled
        y: (0, a.canDragY)(this) && Q ? this.state.y : tt.y
      };
      this.state.isElementSVG ? G = (0, r.createSVGTransform)(K, N) : X = (0, r.createCSSTransform)(K, N);
      const W = (0, n.default)(m.props.className || "", y, {
        [R]: this.state.dragging,
        [H]: this.state.dragged
      });
      return /* @__PURE__ */ i.createElement(l.default, v({}, A, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ i.cloneElement(i.Children.only(m), {
        className: W,
        style: {
          ...m.props.style,
          ...X
        },
        transform: G
      }));
    }
  }
  t.default = D, b(D, "displayName", "Draggable"), b(D, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...l.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: e.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: e.default.oneOfType([e.default.shape({
      left: e.default.number,
      right: e.default.number,
      top: e.default.number,
      bottom: e.default.number
    }), e.default.string, e.default.oneOf([!1])]),
    defaultClassName: e.default.string,
    defaultClassNameDragging: e.default.string,
    defaultClassNameDragged: e.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: e.default.shape({
      x: e.default.number,
      y: e.default.number
    }),
    positionOffset: e.default.shape({
      x: e.default.oneOfType([e.default.number, e.default.string]),
      y: e.default.oneOfType([e.default.number, e.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: e.default.shape({
      x: e.default.number,
      y: e.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: s.dontSetMe,
    style: s.dontSetMe,
    transform: s.dontSetMe
  }), b(D, "defaultProps", {
    ...l.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(ce);
const {
  default: be,
  DraggableCore: to
} = ce;
yt.exports = be;
yt.exports.default = be;
yt.exports.DraggableCore = to;
var eo = yt.exports;
const io = /* @__PURE__ */ Ne(eo);
var _ = function() {
  return _ = Object.assign || function(t) {
    for (var i, e = 1, o = arguments.length; e < o; e++) {
      i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, _.apply(this, arguments);
}, Yt = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, Ut = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, ht = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, oo = {
  top: _(_({}, Yt), { top: "-5px" }),
  right: _(_({}, Ut), { left: void 0, right: "-5px" }),
  bottom: _(_({}, Yt), { top: void 0, bottom: "-5px" }),
  left: _(_({}, Ut), { left: "-5px" }),
  topRight: _(_({}, ht), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: _(_({}, ht), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: _(_({}, ht), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: _(_({}, ht), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, no = De(function(t) {
  var i = t.onResizeStart, e = t.direction, o = t.children, n = t.replaceStyles, r = t.className, a = It(function(u) {
    i(u, e);
  }, [i, e]), s = It(function(u) {
    i(u, e);
  }, [i, e]), l = Wt(function() {
    return _(_({ position: "absolute", userSelect: "none" }, oo[e]), n ?? {});
  }, [n, e]);
  return z.jsx("div", { className: r || void 0, style: l, onMouseDown: a, onTouchStart: s, children: o });
}), ro = /* @__PURE__ */ function() {
  var t = function(i, e) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, n) {
      o.__proto__ = n;
    } || function(o, n) {
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (o[r] = n[r]);
    }, t(i, e);
  };
  return function(i, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    t(i, e);
    function o() {
      this.constructor = i;
    }
    i.prototype = e === null ? Object.create(e) : (o.prototype = e.prototype, new o());
  };
}(), V = function() {
  return V = Object.assign || function(t) {
    for (var i, e = 1, o = arguments.length; e < o; e++) {
      i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, V.apply(this, arguments);
}, so = {
  width: "auto",
  height: "auto"
}, pt = function(t, i, e) {
  return Math.max(Math.min(t, e), i);
}, $t = function(t, i, e) {
  var o = Math.round(t / i);
  return o * i + e * (o - 1);
}, rt = function(t, i) {
  return new RegExp(t, "i").test(i);
}, ft = function(t) {
  return !!(t.touches && t.touches.length);
}, ao = function(t) {
  return !!((t.clientX || t.clientX === 0) && (t.clientY || t.clientY === 0));
}, Gt = function(t, i, e) {
  e === void 0 && (e = 0);
  var o = i.reduce(function(r, a, s) {
    return Math.abs(a - t) < Math.abs(i[r] - t) ? s : r;
  }, 0), n = Math.abs(i[o] - t);
  return e === 0 || n < e ? i[o] : t;
}, Mt = function(t) {
  return t = t.toString(), t === "auto" || t.endsWith("px") || t.endsWith("%") || t.endsWith("vh") || t.endsWith("vw") || t.endsWith("vmax") || t.endsWith("vmin") ? t : "".concat(t, "px");
}, gt = function(t, i, e, o) {
  if (t && typeof t == "string") {
    if (t.endsWith("px"))
      return Number(t.replace("px", ""));
    if (t.endsWith("%")) {
      var n = Number(t.replace("%", "")) / 100;
      return i * n;
    }
    if (t.endsWith("vw")) {
      var n = Number(t.replace("vw", "")) / 100;
      return e * n;
    }
    if (t.endsWith("vh")) {
      var n = Number(t.replace("vh", "")) / 100;
      return o * n;
    }
  }
  return t;
}, lo = function(t, i, e, o, n, r, a) {
  return o = gt(o, t.width, i, e), n = gt(n, t.height, i, e), r = gt(r, t.width, i, e), a = gt(a, t.height, i, e), {
    maxWidth: typeof o > "u" ? void 0 : Number(o),
    maxHeight: typeof n > "u" ? void 0 : Number(n),
    minWidth: typeof r > "u" ? void 0 : Number(r),
    minHeight: typeof a > "u" ? void 0 : Number(a)
  };
}, uo = function(t) {
  return Array.isArray(t) ? t : [t, t];
}, co = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], Kt = "__resizable_base__", ho = (
  /** @class */
  function(t) {
    ro(i, t);
    function i(e) {
      var o, n, r, a, s = t.call(this, e) || this;
      return s.ratio = 1, s.resizable = null, s.parentLeft = 0, s.parentTop = 0, s.resizableLeft = 0, s.resizableRight = 0, s.resizableTop = 0, s.resizableBottom = 0, s.targetLeft = 0, s.targetTop = 0, s.delta = {
        width: 0,
        height: 0
      }, s.appendBase = function() {
        if (!s.resizable || !s.window)
          return null;
        var l = s.parentNode;
        if (!l)
          return null;
        var u = s.window.document.createElement("div");
        return u.style.width = "100%", u.style.height = "100%", u.style.position = "absolute", u.style.transform = "scale(0, 0)", u.style.left = "0", u.style.flex = "0 0 100%", u.classList ? u.classList.add(Kt) : u.className += Kt, l.appendChild(u), u;
      }, s.removeBase = function(l) {
        var u = s.parentNode;
        u && u.removeChild(l);
      }, s.state = {
        isResizing: !1,
        width: (n = (o = s.propsSize) === null || o === void 0 ? void 0 : o.width) !== null && n !== void 0 ? n : "auto",
        height: (a = (r = s.propsSize) === null || r === void 0 ? void 0 : r.height) !== null && a !== void 0 ? a : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, s.onResizeStart = s.onResizeStart.bind(s), s.onMouseMove = s.onMouseMove.bind(s), s.onMouseUp = s.onMouseUp.bind(s), s;
    }
    return Object.defineProperty(i.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || so;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "size", {
      get: function() {
        var e = 0, o = 0;
        if (this.resizable && this.window) {
          var n = this.resizable.offsetWidth, r = this.resizable.offsetHeight, a = this.resizable.style.position;
          a !== "relative" && (this.resizable.style.position = "relative"), e = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : n, o = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : r, this.resizable.style.position = a;
        }
        return { width: e, height: o };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(i.prototype, "sizeStyle", {
      get: function() {
        var e = this, o = this.props.size, n = function(s) {
          var l;
          if (typeof e.state[s] > "u" || e.state[s] === "auto")
            return "auto";
          if (e.propsSize && e.propsSize[s] && (!((l = e.propsSize[s]) === null || l === void 0) && l.toString().endsWith("%"))) {
            if (e.state[s].toString().endsWith("%"))
              return e.state[s].toString();
            var u = e.getParentSize(), c = Number(e.state[s].toString().replace("px", "")), h = c / u[s] * 100;
            return "".concat(h, "%");
          }
          return Mt(e.state[s]);
        }, r = o && typeof o.width < "u" && !this.state.isResizing ? Mt(o.width) : n("width"), a = o && typeof o.height < "u" && !this.state.isResizing ? Mt(o.height) : n("height");
        return { width: r, height: a };
      },
      enumerable: !1,
      configurable: !0
    }), i.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var e = this.appendBase();
      if (!e)
        return { width: 0, height: 0 };
      var o = !1, n = this.parentNode.style.flexWrap;
      n !== "wrap" && (o = !0, this.parentNode.style.flexWrap = "wrap"), e.style.position = "relative", e.style.minWidth = "100%", e.style.minHeight = "100%";
      var r = {
        width: e.offsetWidth,
        height: e.offsetHeight
      };
      return o && (this.parentNode.style.flexWrap = n), this.removeBase(e), r;
    }, i.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, i.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, i.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var e = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: e.flexBasis !== "auto" ? e.flexBasis : void 0
        });
      }
    }, i.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, i.prototype.createSizeForCssProperty = function(e, o) {
      var n = this.propsSize && this.propsSize[o];
      return this.state[o] === "auto" && this.state.original[o] === e && (typeof n > "u" || n === "auto") ? "auto" : e;
    }, i.prototype.calculateNewMaxFromBoundary = function(e, o) {
      var n = this.props.boundsByDirection, r = this.state.direction, a = n && rt("left", r), s = n && rt("top", r), l, u;
      if (this.props.bounds === "parent") {
        var c = this.parentNode;
        c && (l = a ? this.resizableRight - this.parentLeft : c.offsetWidth + (this.parentLeft - this.resizableLeft), u = s ? this.resizableBottom - this.parentTop : c.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (l = a ? this.resizableRight : this.window.innerWidth - this.resizableLeft, u = s ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (l = a ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), u = s ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return l && Number.isFinite(l) && (e = e && e < l ? e : l), u && Number.isFinite(u) && (o = o && o < u ? o : u), { maxWidth: e, maxHeight: o };
    }, i.prototype.calculateNewSizeFromDirection = function(e, o) {
      var n = this.props.scale || 1, r = uo(this.props.resizeRatio || 1), a = r[0], s = r[1], l = this.state, u = l.direction, c = l.original, h = this.props, g = h.lockAspectRatio, v = h.lockAspectRatioExtraHeight, b = h.lockAspectRatioExtraWidth, w = c.width, x = c.height, D = v || 0, f = b || 0;
      return rt("right", u) && (w = c.width + (e - c.x) * a / n, g && (x = (w - f) / this.ratio + D)), rt("left", u) && (w = c.width - (e - c.x) * a / n, g && (x = (w - f) / this.ratio + D)), rt("bottom", u) && (x = c.height + (o - c.y) * s / n, g && (w = (x - D) * this.ratio + f)), rt("top", u) && (x = c.height - (o - c.y) * s / n, g && (w = (x - D) * this.ratio + f)), { newWidth: w, newHeight: x };
    }, i.prototype.calculateNewSizeFromAspectRatio = function(e, o, n, r) {
      var a = this.props, s = a.lockAspectRatio, l = a.lockAspectRatioExtraHeight, u = a.lockAspectRatioExtraWidth, c = typeof r.width > "u" ? 10 : r.width, h = typeof n.width > "u" || n.width < 0 ? e : n.width, g = typeof r.height > "u" ? 10 : r.height, v = typeof n.height > "u" || n.height < 0 ? o : n.height, b = l || 0, w = u || 0;
      if (s) {
        var x = (g - b) * this.ratio + w, D = (v - b) * this.ratio + w, f = (c - w) / this.ratio + b, d = (h - w) / this.ratio + b, p = Math.max(c, x), m = Math.min(h, D), S = Math.max(g, f), y = Math.min(v, d);
        e = pt(e, p, m), o = pt(o, S, y);
      } else
        e = pt(e, c, h), o = pt(o, g, v);
      return { newWidth: e, newHeight: o };
    }, i.prototype.setBoundingClientRect = function() {
      var e = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var o = this.parentNode;
        if (o) {
          var n = o.getBoundingClientRect();
          this.parentLeft = n.left * e, this.parentTop = n.top * e;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var r = this.props.bounds.getBoundingClientRect();
        this.targetLeft = r.left * e, this.targetTop = r.top * e;
      }
      if (this.resizable) {
        var a = this.resizable.getBoundingClientRect(), s = a.left, l = a.top, u = a.right, c = a.bottom;
        this.resizableLeft = s * e, this.resizableRight = u * e, this.resizableTop = l * e, this.resizableBottom = c * e;
      }
    }, i.prototype.onResizeStart = function(e, o) {
      if (!(!this.resizable || !this.window)) {
        var n = 0, r = 0;
        if (e.nativeEvent && ao(e.nativeEvent) ? (n = e.nativeEvent.clientX, r = e.nativeEvent.clientY) : e.nativeEvent && ft(e.nativeEvent) && (n = e.nativeEvent.touches[0].clientX, r = e.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var a = this.props.onResizeStart(e, o, this.resizable);
          if (a === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var s, l = this.window.getComputedStyle(this.resizable);
        if (l.flexBasis !== "auto") {
          var u = this.parentNode;
          if (u) {
            var c = this.window.getComputedStyle(u).flexDirection;
            this.flexDir = c.startsWith("row") ? "row" : "column", s = l.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var h = {
          original: {
            x: n,
            y: r,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: V(V({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(e.target).cursor || "auto" }),
          direction: o,
          flexBasis: s
        };
        this.setState(h);
      }
    }, i.prototype.onMouseMove = function(e) {
      var o = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && ft(e))
          try {
            e.preventDefault(), e.stopPropagation();
          } catch {
          }
        var n = this.props, r = n.maxWidth, a = n.maxHeight, s = n.minWidth, l = n.minHeight, u = ft(e) ? e.touches[0].clientX : e.clientX, c = ft(e) ? e.touches[0].clientY : e.clientY, h = this.state, g = h.direction, v = h.original, b = h.width, w = h.height, x = this.getParentSize(), D = lo(x, this.window.innerWidth, this.window.innerHeight, r, a, s, l);
        r = D.maxWidth, a = D.maxHeight, s = D.minWidth, l = D.minHeight;
        var f = this.calculateNewSizeFromDirection(u, c), d = f.newHeight, p = f.newWidth, m = this.calculateNewMaxFromBoundary(r, a);
        this.props.snap && this.props.snap.x && (p = Gt(p, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (d = Gt(d, this.props.snap.y, this.props.snapGap));
        var S = this.calculateNewSizeFromAspectRatio(p, d, { width: m.maxWidth, height: m.maxHeight }, { width: s, height: l });
        if (p = S.newWidth, d = S.newHeight, this.props.grid) {
          var y = $t(p, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), R = $t(d, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), H = this.props.snapGap || 0, C = H === 0 || Math.abs(y - p) <= H ? y : p, N = H === 0 || Math.abs(R - d) <= H ? R : d;
          p = C, d = N;
        }
        var E = {
          width: p - v.width,
          height: d - v.height
        };
        if (this.delta = E, b && typeof b == "string") {
          if (b.endsWith("%")) {
            var A = p / x.width * 100;
            p = "".concat(A, "%");
          } else if (b.endsWith("vw")) {
            var X = p / this.window.innerWidth * 100;
            p = "".concat(X, "vw");
          } else if (b.endsWith("vh")) {
            var G = p / this.window.innerHeight * 100;
            p = "".concat(G, "vh");
          }
        }
        if (w && typeof w == "string") {
          if (w.endsWith("%")) {
            var A = d / x.height * 100;
            d = "".concat(A, "%");
          } else if (w.endsWith("vw")) {
            var X = d / this.window.innerWidth * 100;
            d = "".concat(X, "vw");
          } else if (w.endsWith("vh")) {
            var G = d / this.window.innerHeight * 100;
            d = "".concat(G, "vh");
          }
        }
        var F = {
          width: this.createSizeForCssProperty(p, "width"),
          height: this.createSizeForCssProperty(d, "height")
        };
        this.flexDir === "row" ? F.flexBasis = F.width : this.flexDir === "column" && (F.flexBasis = F.height);
        var Q = this.state.width !== F.width, tt = this.state.height !== F.height, K = this.state.flexBasis !== F.flexBasis, W = Q || tt || K;
        W && Qt(function() {
          o.setState(F);
        }), this.props.onResize && W && this.props.onResize(e, g, this.resizable, E);
      }
    }, i.prototype.onMouseUp = function(e) {
      var o, n, r = this.state, a = r.isResizing, s = r.direction;
      r.original, !(!a || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(e, s, this.resizable, this.delta), this.props.size && this.setState({ width: (o = this.props.size.width) !== null && o !== void 0 ? o : "auto", height: (n = this.props.size.height) !== null && n !== void 0 ? n : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: V(V({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, i.prototype.updateSize = function(e) {
      var o, n;
      this.setState({ width: (o = e.width) !== null && o !== void 0 ? o : "auto", height: (n = e.height) !== null && n !== void 0 ? n : "auto" });
    }, i.prototype.renderResizer = function() {
      var e = this, o = this.props, n = o.enable, r = o.handleStyles, a = o.handleClasses, s = o.handleWrapperStyle, l = o.handleWrapperClass, u = o.handleComponent;
      if (!n)
        return null;
      var c = Object.keys(n).map(function(h) {
        return n[h] !== !1 ? z.jsx(no, { direction: h, onResizeStart: e.onResizeStart, replaceStyles: r && r[h], className: a && a[h], children: u && u[h] ? u[h] : null }, h) : null;
      });
      return z.jsx("div", { className: l, style: s, children: c });
    }, i.prototype.render = function() {
      var e = this, o = Object.keys(this.props).reduce(function(a, s) {
        return co.indexOf(s) !== -1 || (a[s] = e.props[s]), a;
      }, {}), n = V(V(V({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (n.flexBasis = this.state.flexBasis);
      var r = this.props.as || "div";
      return z.jsxs(r, V({ style: n, className: this.props.className }, o, {
        // `ref` is after `extendsProps` to ensure this one wins over a version
        // passed in
        ref: function(a) {
          a && (e.resizable = a);
        },
        children: [this.state.isResizing && z.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, i.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, i;
  }(Zt)
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Ht = function(t, i) {
  return Ht = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
    e.__proto__ = o;
  } || function(e, o) {
    for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
  }, Ht(t, i);
};
function po(t, i) {
  Ht(t, i);
  function e() {
    this.constructor = t;
  }
  t.prototype = i === null ? Object.create(i) : (e.prototype = i.prototype, new e());
}
var M = function() {
  return M = Object.assign || function(i) {
    for (var e, o = 1, n = arguments.length; o < n; o++) {
      e = arguments[o];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (i[r] = e[r]);
    }
    return i;
  }, M.apply(this, arguments);
};
function fo(t, i) {
  var e = {};
  for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && i.indexOf(o) < 0 && (e[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(t); n < o.length; n++)
      i.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[n]) && (e[o[n]] = t[o[n]]);
  return e;
}
var go = {
  width: "auto",
  height: "auto",
  display: "inline-block",
  position: "absolute",
  top: 0,
  left: 0
}, mo = function(t) {
  return {
    bottom: t,
    bottomLeft: t,
    bottomRight: t,
    left: t,
    right: t,
    top: t,
    topLeft: t,
    topRight: t
  };
}, vo = (
  /** @class */
  function(t) {
    po(i, t);
    function i(e) {
      var o = t.call(this, e) || this;
      return o.resizingPosition = { x: 0, y: 0 }, o.offsetFromParent = { left: 0, top: 0 }, o.resizableElement = { current: null }, o.originalPosition = { x: 0, y: 0 }, o.state = {
        resizing: !1,
        bounds: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        maxWidth: e.maxWidth,
        maxHeight: e.maxHeight
      }, o.onResizeStart = o.onResizeStart.bind(o), o.onResize = o.onResize.bind(o), o.onResizeStop = o.onResizeStop.bind(o), o.onDragStart = o.onDragStart.bind(o), o.onDrag = o.onDrag.bind(o), o.onDragStop = o.onDragStop.bind(o), o.getMaxSizesFromProps = o.getMaxSizesFromProps.bind(o), o;
    }
    return i.prototype.componentDidMount = function() {
      this.updateOffsetFromParent();
      var e = this.offsetFromParent, o = e.left, n = e.top, r = this.getDraggablePosition(), a = r.x, s = r.y;
      this.draggable.setState({
        x: a - o,
        y: s - n
      }), this.forceUpdate();
    }, i.prototype.getDraggablePosition = function() {
      var e = this.draggable.state, o = e.x, n = e.y;
      return { x: o, y: n };
    }, i.prototype.getParent = function() {
      return this.resizable && this.resizable.parentNode;
    }, i.prototype.getParentSize = function() {
      return this.resizable.getParentSize();
    }, i.prototype.getMaxSizesFromProps = function() {
      var e = typeof this.props.maxWidth > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth, o = typeof this.props.maxHeight > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
      return { maxWidth: e, maxHeight: o };
    }, i.prototype.getSelfElement = function() {
      return this.resizable && this.resizable.resizable;
    }, i.prototype.getOffsetHeight = function(e) {
      var o = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerHeight / o;
        case "body":
          return document.body.offsetHeight / o;
        default:
          return e.offsetHeight;
      }
    }, i.prototype.getOffsetWidth = function(e) {
      var o = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerWidth / o;
        case "body":
          return document.body.offsetWidth / o;
        default:
          return e.offsetWidth;
      }
    }, i.prototype.onDragStart = function(e, o) {
      this.props.onDragStart && this.props.onDragStart(e, o);
      var n = this.getDraggablePosition();
      if (this.originalPosition = n, !!this.props.bounds) {
        var r = this.getParent(), a = this.props.scale, s;
        if (this.props.bounds === "parent")
          s = r;
        else if (this.props.bounds === "body") {
          var l = r.getBoundingClientRect(), u = l.left, c = l.top, h = document.body.getBoundingClientRect(), g = -(u - r.offsetLeft * a - h.left) / a, v = -(c - r.offsetTop * a - h.top) / a, b = (document.body.offsetWidth - this.resizable.size.width * a) / a + g, w = (document.body.offsetHeight - this.resizable.size.height * a) / a + v;
          return this.setState({ bounds: { top: v, right: b, bottom: w, left: g } });
        } else if (this.props.bounds === "window") {
          if (!this.resizable)
            return;
          var x = r.getBoundingClientRect(), D = x.left, f = x.top, d = -(D - r.offsetLeft * a) / a, p = -(f - r.offsetTop * a) / a, b = (window.innerWidth - this.resizable.size.width * a) / a + d, w = (window.innerHeight - this.resizable.size.height * a) / a + p;
          return this.setState({ bounds: { top: p, right: b, bottom: w, left: d } });
        } else typeof this.props.bounds == "string" ? s = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (s = this.props.bounds);
        if (!(!(s instanceof HTMLElement) || !(r instanceof HTMLElement))) {
          var m = s.getBoundingClientRect(), S = m.left, y = m.top, R = r.getBoundingClientRect(), H = R.left, C = R.top, N = (S - H) / a, E = y - C;
          if (this.resizable) {
            this.updateOffsetFromParent();
            var A = this.offsetFromParent;
            this.setState({
              bounds: {
                top: E - A.top,
                right: N + (s.offsetWidth - this.resizable.size.width) - A.left / a,
                bottom: E + (s.offsetHeight - this.resizable.size.height) - A.top,
                left: N - A.left / a
              }
            });
          }
        }
      }
    }, i.prototype.onDrag = function(e, o) {
      if (this.props.onDrag) {
        var n = this.offsetFromParent, r = n.left, a = n.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDrag(e, M(M({}, o), { x: o.x + r, y: o.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDrag(e, M(M({}, o), { x: o.x + r, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDrag(e, M(M({}, o), { x: this.originalPosition.x + r, y: o.y + a, deltaX: 0 }));
      }
    }, i.prototype.onDragStop = function(e, o) {
      if (this.props.onDragStop) {
        var n = this.offsetFromParent, r = n.left, a = n.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDragStop(e, M(M({}, o), { x: o.x + r, y: o.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDragStop(e, M(M({}, o), { x: o.x + r, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDragStop(e, M(M({}, o), { x: this.originalPosition.x + r, y: o.y + a, deltaX: 0 }));
      }
    }, i.prototype.onResizeStart = function(e, o, n) {
      e.stopPropagation(), this.setState({
        resizing: !0
      });
      var r = this.props.scale, a = this.offsetFromParent, s = this.getDraggablePosition();
      if (this.resizingPosition = { x: s.x + a.left, y: s.y + a.top }, this.originalPosition = s, this.props.bounds) {
        var l = this.getParent(), u = void 0;
        this.props.bounds === "parent" ? u = l : this.props.bounds === "body" ? u = document.body : this.props.bounds === "window" ? u = window : typeof this.props.bounds == "string" ? u = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (u = this.props.bounds);
        var c = this.getSelfElement();
        if (c instanceof Element && (u instanceof HTMLElement || u === window) && l instanceof HTMLElement) {
          var h = this.getMaxSizesFromProps(), g = h.maxWidth, v = h.maxHeight, b = this.getParentSize();
          if (g && typeof g == "string")
            if (g.endsWith("%")) {
              var w = Number(g.replace("%", "")) / 100;
              g = b.width * w;
            } else g.endsWith("px") && (g = Number(g.replace("px", "")));
          if (v && typeof v == "string")
            if (v.endsWith("%")) {
              var w = Number(v.replace("%", "")) / 100;
              v = b.height * w;
            } else v.endsWith("px") && (v = Number(v.replace("px", "")));
          var x = c.getBoundingClientRect(), D = x.left, f = x.top, d = this.props.bounds === "window" ? { left: 0, top: 0 } : u.getBoundingClientRect(), p = d.left, m = d.top, S = this.getOffsetWidth(u), y = this.getOffsetHeight(u), R = o.toLowerCase().endsWith("left"), H = o.toLowerCase().endsWith("right"), C = o.startsWith("top"), N = o.startsWith("bottom");
          if ((R || C) && this.resizable) {
            var E = (D - p) / r + this.resizable.size.width;
            this.setState({ maxWidth: E > Number(g) ? g : E });
          }
          if (H || this.props.lockAspectRatio && !R && !C) {
            var E = S + (p - D) / r;
            this.setState({ maxWidth: E > Number(g) ? g : E });
          }
          if ((C || R) && this.resizable) {
            var E = (f - m) / r + this.resizable.size.height;
            this.setState({
              maxHeight: E > Number(v) ? v : E
            });
          }
          if (N || this.props.lockAspectRatio && !C && !R) {
            var E = y + (m - f) / r;
            this.setState({
              maxHeight: E > Number(v) ? v : E
            });
          }
        }
      } else
        this.setState({
          maxWidth: this.props.maxWidth,
          maxHeight: this.props.maxHeight
        });
      this.props.onResizeStart && this.props.onResizeStart(e, o, n);
    }, i.prototype.onResize = function(e, o, n, r) {
      var a = this, s = { x: this.originalPosition.x, y: this.originalPosition.y }, l = -r.width, u = -r.height, c = ["top", "left", "topLeft", "bottomLeft", "topRight"];
      c.includes(o) && (o === "bottomLeft" ? s.x += l : (o === "topRight" || (s.x += l), s.y += u));
      var h = this.draggable.state;
      (s.x !== h.x || s.y !== h.y) && Qt(function() {
        a.draggable.setState(s);
      }), this.updateOffsetFromParent();
      var g = this.offsetFromParent, v = this.getDraggablePosition().x + g.left, b = this.getDraggablePosition().y + g.top;
      this.resizingPosition = { x: v, y: b }, this.props.onResize && this.props.onResize(e, o, n, r, {
        x: v,
        y: b
      });
    }, i.prototype.onResizeStop = function(e, o, n, r) {
      this.setState({
        resizing: !1
      });
      var a = this.getMaxSizesFromProps(), s = a.maxWidth, l = a.maxHeight;
      this.setState({ maxWidth: s, maxHeight: l }), this.props.onResizeStop && this.props.onResizeStop(e, o, n, r, this.resizingPosition);
    }, i.prototype.updateSize = function(e) {
      this.resizable && this.resizable.updateSize({ width: e.width, height: e.height });
    }, i.prototype.updatePosition = function(e) {
      this.draggable.setState(e);
    }, i.prototype.updateOffsetFromParent = function() {
      var e = this.props.scale, o = this.getParent(), n = this.getSelfElement();
      if (!o || n === null)
        return {
          top: 0,
          left: 0
        };
      var r = o.getBoundingClientRect(), a = r.left, s = r.top, l = n.getBoundingClientRect(), u = this.getDraggablePosition(), c = o.scrollLeft, h = o.scrollTop;
      this.offsetFromParent = {
        left: l.left - a + c - u.x * e,
        top: l.top - s + h - u.y * e
      };
    }, i.prototype.render = function() {
      var e = this, o = this.props, n = o.disableDragging, r = o.style, a = o.dragHandleClassName, s = o.position, l = o.onMouseDown, u = o.onMouseUp, c = o.dragAxis, h = o.dragGrid, g = o.bounds, v = o.enableUserSelectHack, b = o.cancel, w = o.children;
      o.onResizeStart, o.onResize, o.onResizeStop, o.onDragStart, o.onDrag, o.onDragStop;
      var x = o.resizeHandleStyles, D = o.resizeHandleClasses, f = o.resizeHandleComponent, d = o.enableResizing, p = o.resizeGrid, m = o.resizeHandleWrapperClass, S = o.resizeHandleWrapperStyle, y = o.scale, R = o.allowAnyClick, H = o.dragPositionOffset, C = fo(o, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick", "dragPositionOffset"]), N = this.props.default ? M({}, this.props.default) : void 0;
      delete C.default;
      var E = n || a ? { cursor: "auto" } : { cursor: "move" }, A = M(M(M({}, go), E), r), X = this.offsetFromParent, G = X.left, F = X.top, Q;
      s && (Q = {
        x: s.x - G,
        y: s.y - F
      });
      var tt = this.state.resizing ? void 0 : Q, K = this.state.resizing ? "both" : c;
      return kt(
        io,
        {
          ref: function(W) {
            W && (e.draggable = W);
          },
          handle: a ? ".".concat(a) : void 0,
          defaultPosition: N,
          onMouseDown: l,
          // @ts-expect-error
          onMouseUp: u,
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop,
          axis: K,
          disabled: n,
          grid: h,
          bounds: g ? this.state.bounds : void 0,
          position: tt,
          enableUserSelectHack: v,
          cancel: b,
          scale: y,
          allowAnyClick: R,
          nodeRef: this.resizableElement,
          positionOffset: H
        },
        kt(ho, M({}, C, { ref: function(W) {
          W && (e.resizable = W, e.resizableElement.current = W.resizable);
        }, defaultSize: N, size: this.props.size, enable: typeof d == "boolean" ? mo(d) : d, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: A, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight, grid: p, handleWrapperClass: m, handleWrapperStyle: S, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: x, handleClasses: D, handleComponent: f, scale: this.props.scale }), w)
      );
    }, i.defaultProps = {
      maxWidth: Number.MAX_SAFE_INTEGER,
      maxHeight: Number.MAX_SAFE_INTEGER,
      scale: 1,
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      onDragStart: function() {
      },
      onDrag: function() {
      },
      onDragStop: function() {
      }
    }, i;
  }(Zt)
);
const yo = ut()(({ constructs: t, mixins: i, borderRadiuses: e }) => ({
  root: {
    alignContent: "center",
    backgroundColor: t.surface.neutral.inverted,
    border: "none",
    borderBottomLeftRadius: k.ifFeature("encore", e[300], void 0),
    borderBottomRightRadius: k.ifFeature("encore", e[300], void 0),
    display: "flex",
    fill: t.icon.neutral.strong,
    height: "100%",
    justifyContent: "center",
    overflow: "hidden",
    width: "100%",
    "&:focus-visible": {
      ":after": {
        borderBottomLeftRadius: e[300],
        borderBottomRightRadius: e[300],
        bottom: "2px",
        boxShadow: `0px 0px 0px 2px ${i.alpha(t.surface.primary.medium, 0.8)}`,
        content: '""',
        height: "18px",
        left: "1px",
        position: "absolute",
        right: "1px",
        top: "0px"
      }
    },
    "&:hover": {
      cursor: "ns-resize",
      fill: t.icon.neutral.xxStrong
    },
    "&:active": {
      fill: t.icon.primary.strong
    }
  }
})), bo = ({ containerRef: t }) => {
  const { classes: i } = yo();
  return /* @__PURE__ */ z.jsx(
    "button",
    {
      "aria-label": window.jQuery ? $.__("Resize dialog") : "Resize dialog",
      className: `${i.root} resize-handle`,
      ref: t,
      type: "button",
      children: /* @__PURE__ */ z.jsx(Be, { name: "grip-lines-solid", size: 16 })
    }
  );
}, wo = ut()(({ borderRadiuses: t, constructs: i, mixins: e }, { footer: o }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative",
    border: "none",
    padding: 0,
    margin: 0,
    width: "100%"
  },
  childrenWrapper: {
    height: "100%",
    overflowY: "auto",
    position: "relative",
    scrollbarGutter: "stable",
    ":focus-visible": {
      // Adds a focus ring around the main Dialog content when tabbed to
      borderBottomLeftRadius: o ? void 0 : t[300],
      borderBottomRightRadius: o ? void 0 : t[300],
      outline: `2px solid ${e.alpha(i.surface.primary.medium, 0.8)}`,
      outlineOffset: o ? void 0 : "2px"
    }
  },
  bottomFade: {
    bottom: "0",
    position: "sticky",
    zIndex: 1,
    height: 0,
    pointerEvents: "none",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      height: "56px",
      background: `linear-gradient(to top, ${i.surface.neutral.inverted}, transparent 100%)`,
      opacity: 1,
      visibility: "hidden",
      width: "100%",
      ...!o && {
        borderBottomLeftRadius: t[400]
      }
    },
    '&[data-visible="true"]::after': {
      visibility: "visible"
    }
  }
}));
function xo(t, i, e, o) {
  const n = U(!1);
  J(() => {
    e != null && e.current && i && !n.current && window.dispatchEvent(
      new CustomEvent("dialogOpened", {
        bubbles: !0,
        detail: {
          id: o
        }
      })
    ), n.current = !!i;
    const r = (a) => {
      var s;
      i && o !== a.detail.id && ((s = t.current) == null || s.onClose());
    };
    return window.addEventListener("dialogOpened", r), () => {
      window.removeEventListener("dialogOpened", r);
    };
  }, [e, o, i, t]);
}
const So = (t, i) => {
  var e;
  J(() => {
    if (t.current && i.current) {
      const o = t.current, n = () => {
        const { scrollTop: r, scrollHeight: a, clientHeight: s } = o, l = Math.ceil(r + s) >= a - 1, c = a > s && !l;
        i.current.setAttribute("data-visible", c ? "true" : "false");
      };
      return n(), o.addEventListener("scroll", n), () => {
        o.removeEventListener("scroll", n);
      };
    }
  }, [(e = t.current) == null ? void 0 : e.clientHeight]);
};
function zo(t) {
  const { children: i, containerRef: e, id: o, open: n, scrollContainerRef: r, header: a, footer: s } = t, l = U(null), u = U(null), c = U(null), { classes: h } = wo({ footer: !!s });
  So(c, u);
  const g = (v) => {
    v.key === "Escape" && l.current && l.current.onClose();
  };
  return xo(l, n, e, o), /* @__PURE__ */ z.jsx(ie.Provider, { value: { closeButtonApiRef: l }, children: /* @__PURE__ */ z.jsxs("dialog", { className: h.root, onKeyDown: g, ref: e, children: [
    a,
    /* @__PURE__ */ z.jsxs(
      "div",
      {
        className: h.childrenWrapper,
        ref: ee(r, c),
        tabIndex: 0,
        children: [
          i,
          /* @__PURE__ */ z.jsx("div", { className: h.bottomFade, ref: u })
        ]
      }
    ),
    s
  ] }) });
}
const Do = (t, i, { boundaryRef: e, containerRef: o, decoyRef: n }) => {
  const [, r] = ot();
  J(() => {
    const a = setTimeout(() => {
      o.current && n.current && t && !i && r.calculateInitialSizeAndPosition({ boundaryRef: e, containerRef: o, decoyRef: n });
    }, 100);
    return () => {
      clearTimeout(a);
    };
  }, [t, i]);
}, Ro = (t, { containerRef: i, rndRef: e, boundaryRef: o }) => {
  const [, n] = ot();
  J(() => {
    t !== !1 && i.current && e.current && o.current && n.keepInBounds({
      boundaryRef: o,
      containerRef: i,
      rndRef: e
    });
  }, [t, n, o, i, e]);
}, Eo = (t, i, e) => {
  if (t.current && i.current && e) {
    const { x: o, y: n } = Tt(t, i);
    e(`${n}px`, `${o}px`);
  }
}, Po = (t) => {
  const { boundaryRef: i, containerRef: e, decoyRef: o, draggable: n, onDrag: r, onResize: a, resizable: s, rndRef: l } = t, [, u] = ot();
  J(() => {
    const c = () => {
      if (!u.isWindowSmallHorizontally(t)) {
        if (n)
          u.keepInBounds(t), Eo(e, o, r);
        else {
          const g = u.updateWindowWidth(document.documentElement.clientWidth);
          g instanceof Promise && g.catch(() => {
          }), u.moveHorizontallyWithWindow(e);
        }
        s && u.updateWindowResizeHeight({ boundaryRef: i, containerRef: e, decoyRef: o, draggable: n, onResize: a, resizable: s, rndRef: l });
      }
      s || u.moveVerticallyWithWindow(e, i);
    };
    return window.addEventListener("resize", c), () => {
      window.removeEventListener("resize", c);
    };
  }, [u, t]);
}, Co = (t, i) => {
  const [, e] = ot();
  J(() => {
    t === !1 && e.resetStore(i);
  }, [t]);
}, _o = ({ onResize: t, resizeHandleRef: i }) => {
  const [, e] = ot();
  J(() => {
    const o = i.current;
    if (!o)
      return;
    const n = (r) => {
      const a = {
        event: r,
        onResize: t
      };
      e.handleKeyboardResize(a);
    };
    return o.addEventListener("keydown", n), () => {
      o.removeEventListener("keydown", n);
    };
  }, [i.current]);
}, Mo = ({
  dragHandleRef: t,
  containerRef: i,
  decoyRef: e,
  boundaryRef: o,
  rndRef: n,
  onDrag: r
}) => {
  const [, a] = ot();
  J(() => {
    const s = t.current;
    if (!s)
      return;
    const l = (u) => {
      const c = {
        boundaryRef: o,
        containerRef: i,
        decoyRef: e,
        event: u,
        onDrag: r,
        rndRef: n
      };
      a.handleKeyboardRepositioning(c);
    };
    return s.addEventListener("keydown", l), () => {
      s.removeEventListener("keydown", l);
    };
  }, [t.current]);
}, Ho = ({ initialSize: t, draggable: i, resizable: e, open: o, onDrag: n, onResize: r }) => {
  const a = U(null), s = U(null), l = U(null), u = U(null), c = U(null), h = U(null), g = U(null), [
    { position: v, absolutePositionCalculated: b, showDialog: w, size: x },
    { updateSize: D, onResizeEnd: f, onResizeFunction: d, onResizeStart: p, handleDragStop: m, updateWindowHeight: S }
  ] = ot();
  return J(() => {
    if (o === !0) {
      const R = D(t);
      R instanceof Promise && R.catch(() => {
      });
    }
    const y = S(document.documentElement.clientHeight);
    y instanceof Promise && y.catch(() => {
    });
  }, [o, t]), Do(o, b, { boundaryRef: l, containerRef: s, decoyRef: h }), Ro(b, { boundaryRef: l, containerRef: s, rndRef: a }), Co(o, t), Po({
    boundaryRef: l,
    containerRef: s,
    decoyRef: h,
    draggable: i,
    onDrag: n,
    onResize: r,
    resizable: e,
    rndRef: a
  }), _o({
    onResize: r,
    resizeHandleRef: g
  }), Mo({
    boundaryRef: l,
    containerRef: s,
    decoyRef: h,
    dragHandleRef: u,
    onDrag: n,
    rndRef: a
  }), {
    callbacks: {
      handleDragStop: m,
      onResizeEnd: f,
      onResizeFunction: d,
      onResizeStart: p
    },
    refs: {
      bottomFadeRef: c,
      boundaryRef: l,
      containerRef: s,
      decoyRef: h,
      dragHandleRef: u,
      resizeHandleRef: g,
      rndRef: a
    },
    state: {
      position: v,
      showDialog: w,
      size: x
    }
  };
}, Wo = ({
  children: t,
  draggable: i = !1,
  footer: e,
  header: o,
  height: n,
  id: r,
  initialHeight: a,
  initialOffsetRight: s,
  initialOffsetTop: l,
  offsetRight: u,
  offsetTop: c,
  onDrag: h,
  onResize: g,
  open: v,
  scrollContainerRef: b,
  resizable: w = !1,
  width: x = Ot
}) => {
  const D = a || n || Nt, f = s || u || ne, d = l || c || re, p = He(v), m = Wt(
    () => ({
      height: D,
      width: x
    }),
    [D, x]
  ), {
    refs: { boundaryRef: S, containerRef: y, decoyRef: R, dragHandleRef: H, resizeHandleRef: C, rndRef: N },
    state: { position: E, size: A, showDialog: X },
    callbacks: { onResizeEnd: G, onResizeStart: F, onResizeFunction: Q, handleDragStop: tt }
  } = Ho({ draggable: i, initialSize: m, onDrag: h, onResize: g, open: v, resizable: w }), { cx: K, classes: W } = mi({
    initialHeight: D,
    initialOffsetRight: f,
    initialOffsetTop: d,
    open: v,
    resizable: w,
    width: x,
    zIndex: p
  });
  return /* @__PURE__ */ z.jsxs("div", { className: K(W.boundaryContainer), "data-fabric-component": "Dialog", ref: S, children: [
    /* @__PURE__ */ z.jsx("div", { className: K(W.root, W.hiddenDialog), ref: R }),
    /* @__PURE__ */ z.jsx(
      vo,
      {
        bounds: "parent",
        className: K(W.root, { [W.visible]: X }),
        disableDragging: !i,
        dragHandleClassName: "drag-handle",
        enableResizing: {
          bottom: w,
          bottomLeft: !1,
          bottomRight: !1,
          left: !1,
          right: !1,
          top: !1,
          topLeft: !1,
          topRight: !1
        },
        id: r,
        maxHeight: window.innerHeight - ct - mt,
        minHeight: at,
        onDragStop: (St, zt) => tt(zt, y, R, h),
        onResize: (St, zt, Dt, xe, Se) => Q(Dt),
        onResizeStart: F,
        onResizeStop: (St, zt, Dt, xe, Se) => G(Dt, g),
        position: E,
        ref: N,
        resizeHandleClasses: {
          bottom: W.resizeHandleOverrides
        },
        resizeHandleComponent: {
          bottom: /* @__PURE__ */ z.jsx(bo, { containerRef: C })
        },
        size: A,
        children: /* @__PURE__ */ z.jsx(oe.Provider, { value: { draggable: i, dragHandleRef: H }, children: /* @__PURE__ */ z.jsx(
          zo,
          {
            containerRef: y,
            footer: w ? /* @__PURE__ */ z.jsxs(Re, { children: [
              e,
              /* @__PURE__ */ z.jsx(Te, { height: ae })
            ] }) : e,
            header: o,
            id: r,
            open: v,
            scrollContainerRef: b,
            children: t
          }
        ) })
      }
    )
  ] });
}, we = (t) => {
  const { container: i, id: e, open: o } = t, n = Wt(() => typeof e == "string" ? e : Pe.uniqueId("fabric-dialog-"), [e]), r = i ? document.getElementById(i) : document.body;
  return o && r ? Ee.createPortal(
    /* @__PURE__ */ z.jsx(gi, { scope: n, children: /* @__PURE__ */ z.jsx(Wo, { ...t, id: n }) }),
    r
  ) : null;
};
we.Header = ke;
we.Footer = Fe;
export {
  we as D,
  bo as R
};
//# sourceMappingURL=dialog-DVtrndKd.mjs.map
